import React from 'react';
import { Box, Card, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FormulaTable } from '@/features';

export const EditableFormula = () => {
  const { t } = useTranslation();

  return (
    <Stack direction="column" gap={2} mb={28}>
      <Box>
        <Typography variant="h2" gutterBottom mt={4}>
          {t('INGREDIENT.FORMULA')}
        </Typography>
        <Typography variant="body1">{t('INGREDIENT.DESCRIPTION')}</Typography>
      </Box>
      <Card sx={{ width: '100%' }}>
        <FormulaTable />
      </Card>
    </Stack>
  );
};
